export const fncClassName = (value?: number | null) => {
	if (!value) return "text-[var(--light-gray)]";
	if (value < 0) return "text-error-light";
	return "text-success-light";
};
